import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ICompany } from '@verzekeringapp-mono/shared/src/api/types/company'
import React from 'react'

interface IProps {
  location: ICompany
}

const LocationCard = ({ location }: IProps) => (
  <div className='mt-4 flex items-center justify-between rounded-md bg-surface-card p-4'>
    <div className='flex gap-4 items-center'>
      <div className='flex h-10 w-10 items-center justify-center rounded-full bg-surface-brand-subtle p-8'>
        <span className='text-center text-text-brand'>
          {location.distance &&
            Intl.NumberFormat('nl-NL', {
              style: 'unit',
              unit: 'kilometer',
              maximumFractionDigits: 2,
              unitDisplay: 'short'
            }).format(location.distance)}
        </span>
      </div>

      <a
        href={location.mapsLink}
        target='_blank'
        rel='noreferrer'
      >
        <h2 className='text-base font-bold'>{location.name}</h2>

        <p className='text-sm text-text-muted underline'>{location.street}</p>

        <p className='text-sm text-text-muted underline'>
          {location.zipCode}
          &nbsp;
          {location.city}
        </p>
      </a>
    </div>

    <div className='flex flex-col gap-4 '>
      {
        location.phoneNumber && location.phoneNumber !== '' && (
          <div className='flex items-center justify-center rounded-full bg-action-primary-background p-2'>
            <a
              href={`tel:${location.phoneNumber}`}
              className='flex h-4 w-4 items-center justify-center text-icon-on-brand'
            >
              <FontAwesomeIcon icon='phone' />
            </a>
          </div>
        )
      }

      {
        location.email && location.email !== '' && (
          <div className='flex items-center justify-center rounded-full bg-action-primary-background p-2'>
            <a
              href={`mailto:${location.email}`}
              className='flex h-4 w-4 items-center justify-center text-icon-on-brand'
            >
              <FontAwesomeIcon icon='envelope' />
            </a>
          </div>
        )
      }

      {
        location.website && location.website !== '' && (
          <div className='flex items-center justify-center rounded-full bg-action-primary-background p-2'>
            <a
              href={
                location.website?.startsWith('http')
                  ? location.website
                  : `http://${location.website}`
              }
              className='flex h-4 w-4 items-center justify-center text-icon-on-brand'
              target='_blank'
              rel='noreferrer'
            >
              <FontAwesomeIcon icon='globe' />
            </a>
          </div>
        )
      }

    </div>
  </div>
)

export default LocationCard
